// Home page scaffold (landing/overview).

import { ServicesCarousel } from "../components/sections/home/ServicesCarousel";
import HomeHero from "../components/sections/home/HomeHero";
import ValuesPreview from "../components/sections/home/ValuesPreview";
import FAQAccordion from "../components/sections/home/FAQAccordion";

export default function HomePage() {


  return (
    <>
      {/*Hero section with auto-sliding text and a static image */}
      <HomeHero />
      {/* Section that previews available services using Swiper carousel */}
      <ServicesCarousel />
      {/* Section that highlights the company's vision, mission, and goals */}
      <ValuesPreview />
      {/* FAQ section with an accordion for common questions */}
      <FAQAccordion />

    </>
  );
}
